(() => {
  function initialiseGallery(gallery) {
    if (gallery.dataset.krigerheimGalleryArrows === 'true') return;

    const thumbnailSlider = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbnailSlider) return;

    const thumbnailList = thumbnailSlider.querySelector(
      '[id^="Slider-Thumbnails-"]'
    );

    const previousButton = thumbnailSlider.querySelector(
      'button[name="previous"]'
    );

    const nextButton = thumbnailSlider.querySelector(
      'button[name="next"]'
    );

    if (!thumbnailList || !previousButton || !nextButton) return;

    /*
     * IMPORTANT:
     * Do NOT filter by visibility here.
     *
     * On mobile Refresh can visually hide the thumbnails while
     * leaving them in the DOM. We still want to use them.
     */
    const getThumbnails = () =>
      Array.from(
        thumbnailList.querySelectorAll('[data-target]')
      );

    const getCurrentIndex = (items) => {
      const currentButton = thumbnailList.querySelector(
        '.thumbnail[aria-current="true"]'
      );

      const currentItem = currentButton?.closest('[data-target]');

      return items.indexOf(currentItem);
    };

    const enableLoopArrows = () => {
      const items = getThumbnails();

      if (items.length <= 1) {
        previousButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      previousButton.disabled = false;
      nextButton.disabled = false;

      previousButton.removeAttribute('disabled');
      nextButton.removeAttribute('disabled');

      previousButton.setAttribute('aria-disabled', 'false');
      nextButton.setAttribute('aria-disabled', 'false');
    };

    const scheduleArrowRepair = () => {
      requestAnimationFrame(enableLoopArrows);
      setTimeout(enableLoopArrows, 50);
      setTimeout(enableLoopArrows, 250);
    };

    const changeMedia = (direction, event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const items = getThumbnails();

      if (items.length <= 1) return;

      let currentIndex = getCurrentIndex(items);

      if (currentIndex < 0) {
        currentIndex = 0;
      }

      const targetIndex =
        (currentIndex + direction + items.length) % items.length;

      const targetButton =
        items[targetIndex]?.querySelector('.thumbnail');

      if (!targetButton) return;

      /*
       * Let Refresh perform the actual media change.
       *
       * We don't touch:
       * src
       * srcset
       * sizes
       * media classes
       * scroll positions
       */
      targetButton.click();

      scheduleArrowRepair();
    };

    previousButton.addEventListener(
      'click',
      (event) => changeMedia(-1, event),
      true
    );

    nextButton.addEventListener(
      'click',
      (event) => changeMedia(1, event),
      true
    );

    thumbnailList
      .querySelectorAll('.thumbnail')
      .forEach((button) => {
        button.addEventListener(
          'click',
          scheduleArrowRepair
        );
      });

    const thumbnailObserver = new MutationObserver(
      scheduleArrowRepair
    );

    thumbnailObserver.observe(thumbnailList, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });

    scheduleArrowRepair();

    setTimeout(enableLoopArrows, 750);

    gallery.dataset.krigerheimGalleryArrows = 'true';
  }

  function initialiseAllGalleries() {
    document
      .querySelectorAll('media-gallery')
      .forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllGalleries
    );
  } else {
    initialiseAllGalleries();
  }

  document.addEventListener(
    'shopify:section:load',
    initialiseAllGalleries
  );
})();